var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideBarStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.1817C2.91554 13.6546 4.92209 12.6094 8.0526 12.6094C11.1831 12.6094 13.1897 13.6546 14.1052 15.1817M14.6844 11.4514C16.3422 12.2804 17.1711 13.1093 18 14.7671M12.9602 5.11564C13.7402 5.53527 14.2705 6.35924 14.2705 7.30706C14.2705 8.2275 13.7704 9.03114 13.0272 9.46111M10.5393 7.30704C10.5393 8.68042 9.42598 9.79376 8.0526 9.79376C6.67922 9.79376 5.56587 8.68042 5.56587 7.30704C5.56587 5.93366 6.67922 4.82031 8.0526 4.82031C9.42598 4.82031 10.5393 5.93366 10.5393 7.30704Z",
    stroke: "#FAFAFA",
    strokeWidth: 1.68315,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarStudent);
export default __webpack_public_path__ + "static/media/SideBarStudent.f548717bbd9fe6f8c723ec316f121956.svg";
export { ForwardRef as ReactComponent };